import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from '@axa-asia/emma-stylesheet';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { getChangeAddressLabels } from '../../../selectors/changeAddressSelector';
import { gaClickAbleElement } from '../../../../../utils/generalGaEventAnalytics';
import { resolveLocalizedText } from '../../../../../utils';

type SameAddressDialogProps = {
  isShow: boolean;
  onClose: () => void;
};

const SameAddressDialog: FC<SameAddressDialogProps> = ({ isShow, onClose }) => {
  // Error Code: CICER23
  const { sameAddress, sameAddressDesc, backBtnLabel } = useSelector(
    getChangeAddressLabels,
  );
  return (
    <Dialog show={isShow}>
      <DialogHeader>
        <span>{resolveLocalizedText(sameAddress)}</span>
      </DialogHeader>
      <DialogBody>
        <div>{resolveLocalizedText(sameAddressDesc)}</div>
      </DialogBody>
      <DialogFooter>
        <div>
          <button
            className="emma-stylesheet-primary-default-button"
            onClick={() => {
              gaClickAbleElement(
                resolveLocalizedText(backBtnLabel),
                'Same Address',
              );
              onClose();
            }}
          >
            {resolveLocalizedText(backBtnLabel)}
          </button>
        </div>
      </DialogFooter>
    </Dialog>
  );
};

export default React.memo(SameAddressDialog);
